import { useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetContestVoteCountQuery = (contestId: number) =>
  useQuery({
    queryKey: contestsQueryKey.contestsVoteCount(contestId),
    queryFn: () => ContestApi.getVoteCount(contestId),
    enabled: contestId > 0,
    staleTime: 1000 * 60 * 5,
  });
